import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const FixturesShowcasePreviewImage = styled(FallbackImage).attrs({
  className:
    "h-14 w-14 rounded-[16px] border border-[rgba(255,255,255,0.14)] bg-[rgba(255,255,255,0.05)] object-cover shadow-[0_10px_18px_rgba(0,0,0,0.22)]",
})``;

export const FixturesShowcaseTextGroup = styled.div.attrs({ className: "min-w-0" })``;
